import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useGlobal } from 'reactn';
import { formatLongDate, formatCurrencyNum } from '../../../helpers';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import Speedpay from './Speedpay_Footer';
import autoPay from '../../assets/auto-pay.png';
import autoPayDocument from '../../assets/documents/AUTO_PAY_FORM.pdf';
import api from '../../../api';

const CurrentBill = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  // lets make sure that all required data is present before screen renders
  if (
    !selectedServiceAccount.billingHistory ||
    !selectedServiceAccount.consumptionData ||
    !selectedServiceAccount.eBillStatus ||
    !selectedServiceAccount.meterData ||
    !selectedServiceAccount.pastPaymentData ||
    !selectedServiceAccount.summaryData
  ) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <Spin tip="Loading account information. Please stand by." />
      </div>
    );
  }

  const { AUTO_PAY } = selectedServiceAccount?.data;
  const { latestBillUrl } = selectedServiceAccount?.summaryData.data;

  return (
    <Card
      title="Current Bill"
      titleExternal="View Current Bill >"
      titleExternalLinkTo={latestBillUrl}
      headerGroupClassName="w-full"
      titleClassName="flex justify-between items-center w-full"
      titleLinkClassName="text-xs ml-10 text-right text-white normal-case"
      titleExternalClassname="text-xs ml-2 text-right text-white normal-case"
      backgroundClass="bg-blue-dark flex flex-col"
      {...rest}
    >
      <div className="flex justify-between">
        <div>
          <h4 className="mb-4 text-white font-medium">Payment Due</h4>
          <p className="text-2xl text-white mb-8">
            {selectedServiceAccount.data.DUE_DATE ? formatLongDate(
                selectedServiceAccount.data.DUE_DATE,
                selectedServiceAccount
            ) : 'Bill Not Due'}
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-white font-medium">Amount Due</h4>
          <p className="text-2xl text-white mb-10">
            {formatCurrencyNum(
              selectedServiceAccount.summaryData.data.accountBalance
            )}
          </p>
        </div>
        <div className="h-full flex flex-col align-center w-2/5">
          <Speedpay customerAccount={selectedServiceAccount.data} />
          {!AUTO_PAY && (
            <Button
              iconUrl={autoPay}
              href={autoPayDocument}
              target="_blank"
              rel="noopener noreferrer"
              secondary
              className="w-full"
            >
              Setup Automatic Bill Pay (No Fee)
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default CurrentBill;
